import {ShopContext as ShopContextInterface} from '@web-utilities/shop';
import {useLoaderData} from 'react-router-dom';
import {LoaderType} from 'foundation/loader';

export const ShopContext = ({children}: {children: React.ReactNode}) => {
  const {shop: data} = useLoaderData<LoaderType>();

  return (
    <ShopContextInterface.Provider value={data}>
      {children}
    </ShopContextInterface.Provider>
  );
};
